// Environment configuration for Reqqy
export const config = {
  backendUrl: import.meta.env.VITE_BACKEND_URL || 'https://reqqy-backend.onrender.com',
  wsProtocol: import.meta.env.VITE_WS_PROTOCOL || 'ws',
  env: import.meta.env.MODE || 'development',

  /** Set to true to enable the geo-localized cookie consent banner & GA tracking */
  enableCookieConsent: false,
} as const;

export const getWsUrl = (path: string): string => {
  const baseUrl = config.backendUrl.replace(/^http/, config.wsProtocol);
  return `${baseUrl}${path}`;
};
